module.exports = __webpack_public_path__ + "media/images/homepage_images/cover_1-ebf1df7e1bde560cfc572f7d8b696bdd.png";